"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SavedItemsToolbar = SavedItemsToolbar;
var _react = require("react");
var _materialSymbols = require("@design/icons/material-symbols");
var _badge = require("@design/ui/badge");
var _button = require("@design/ui/button");
var _filterPillBar = require("./filter-pill-bar");
var _expandableSearchBar = require("./expandable-search-bar");
var _categoryFilterDropdown = require("./category-filter-dropdown");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function SavedItemsToolbar(_ref) {
  var _ref$filterButtons = _ref.filterButtons,
    filterButtons = _ref$filterButtons === void 0 ? [] : _ref$filterButtons,
    activeFilter = _ref.activeFilter,
    onFilterChange = _ref.onFilterChange,
    searchQuery = _ref.searchQuery,
    onSearchChange = _ref.onSearchChange,
    searchPlaceholder = _ref.searchPlaceholder,
    categories = _ref.categories,
    selectedCategories = _ref.selectedCategories,
    onToggleCategory = _ref.onToggleCategory,
    _ref$categoryLabel = _ref.categoryLabel,
    categoryLabel = _ref$categoryLabel === void 0 ? "category" : _ref$categoryLabel,
    actions = _ref.actions,
    onCreate = _ref.onCreate,
    _ref$createLabel = _ref.createLabel,
    createLabel = _ref$createLabel === void 0 ? "Create" : _ref$createLabel;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    searchExpanded = _useState2[0],
    setSearchExpanded = _useState2[1];
  var hasPills = filterButtons.length > 0 && activeFilter !== undefined && onFilterChange !== undefined;
  var selectedButton = hasPills ? filterButtons.find(function (button) {
    return button.mode === activeFilter;
  }) : undefined;
  var handleSearchExpandedChange = function handleSearchExpandedChange(expanded) {
    setSearchExpanded(expanded);
    if (!expanded) onSearchChange("");
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center px-3 py-2 gap-2 border-b border-border-default",
    "data-sentry-component": "SavedItemsToolbar",
    "data-sentry-source-file": "saved-items-toolbar.tsx",
    children: [hasPills ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "relative flex-1 min-w-0",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex items-center gap-1.5 overflow-x-auto focus-ring-room",
        style: {
          scrollbarWidth: "none"
        },
        children: searchExpanded && selectedButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_filterPillBar.CollapsedFilterPill, {
          button: selectedButton,
          onClick: function onClick() {
            return handleSearchExpandedChange(false);
          }
        }) : filterButtons.map(function (button) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_filterPillBar.FilterPill, {
            button: button,
            isActive: activeFilter === button.mode,
            onClick: function onClick() {
              return onFilterChange === null || onFilterChange === void 0 ? void 0 : onFilterChange(button.mode);
            }
          }, button.mode);
        })
      }), !searchExpanded && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "absolute inset-y-0 right-0 w-6 bg-linear-to-l from-background-canvas to-transparent pointer-events-none"
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex-1"
    }), actions, /*#__PURE__*/(0, _jsxRuntime.jsx)(_expandableSearchBar.ExpandableSearchBar, {
      value: searchQuery,
      onChange: onSearchChange,
      placeholder: searchPlaceholder,
      isExpanded: searchExpanded,
      onExpandedChange: handleSearchExpandedChange,
      keepOpenWithValue: true,
      className: "shrink-0",
      "data-sentry-element": "ExpandableSearchBar",
      "data-sentry-source-file": "saved-items-toolbar.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_categoryFilterDropdown.CategoryFilterDropdown, {
      categories: categories,
      selectedCategories: selectedCategories,
      onToggleCategory: onToggleCategory,
      categoryLabel: categoryLabel,
      trigger: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
        variant: selectedCategories.length > 0 ? "secondary" : "ghost",
        size: "icon-sm",
        title: "Filter by ".concat(categoryLabel),
        "aria-label": "Filter by ".concat(categoryLabel),
        className: "relative shrink-0",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.FilterAltIcon, {}), selectedCategories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_badge.Badge, {
          variant: "primary",
          size: "sm",
          "data-number": "true",
          className: "absolute -top-1 -right-1",
          children: selectedCategories.length
        })]
      }),
      "data-sentry-element": "CategoryFilterDropdown",
      "data-sentry-source-file": "saved-items-toolbar.tsx"
    }), onCreate && /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      variant: "ghost",
      size: "icon-sm",
      onClick: onCreate,
      title: createLabel,
      "aria-label": createLabel,
      className: "shrink-0",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AddIcon, {})
    })]
  });
}